import type { paths } from "@/api-schema";
import { useModelFamilyByUuidQuery } from "@/common/api/model-family/use-model-family-by-uuid.query";
import { CenteredLayout, CenteredLayoutVariant } from "@/components/layouts/centered-layout";
import { UuidExistenceWrapper } from "@/components/uuid-existence-wrapper/uuid-existence-wrapper";
import { useTranslation } from "react-i18next";
import { useParams } from "wouter";
import { ModelFamilyFormFields } from "../_components/model-family-form-fields";

interface ModelFamilyUpdateViewParams {
  uuid: string;
}

export function ModelFamilyUpdateView() {
  const { t } = useTranslation(["masterdata", "common"]);
  const params = useParams<ModelFamilyUpdateViewParams>();
  const uuid = params.uuid;

  return (
    <UuidExistenceWrapper<
      paths["/v1/model-family/{uuid}"]["get"]["parameters"]["query"],
      paths["/v1/model-family/{uuid}"]["get"]["responses"][200]["content"]["application/json"]
    >
      uuid={uuid}
      query={useModelFamilyByUuidQuery}
      notFoundProps={{
        title: t("masterdata:ModelFamilyNotFound"),
        message: t("masterdata:ModelFamilyDoesNotExist"),
        description: t("masterdata:CheckModelFamilyIdOrContactSupport"),
        backTo: "~/masterdata/model-family",
        backToLabel: t("masterdata:BackToModelFamilyOverview"),
      }}
    >
      <ModelFamilyUpdateViewContent uuid={uuid} />
    </UuidExistenceWrapper>
  );
}

function ModelFamilyUpdateViewContent({ uuid }: { uuid: string }) {
  const { t } = useTranslation(["masterdata", "common"]);
  const pageTitle = t("masterdata:EditModelFamily");
  const pageSubtitle = t("common:ReviewAndSaveChangesDescription");

  return (
    <CenteredLayout variant={CenteredLayoutVariant.Form} title={pageTitle} subTitle={pageSubtitle}>
      <ModelFamilyFormFields uuid={uuid} />
    </CenteredLayout>
  );
}
